import React from 'react';
import {
  Box,
  Grid,
  TextField,
  FormControl,
  FormControlLabel,
  InputLabel,
  Select,
  MenuItem,
  Link,
  Alert,
  Checkbox,
  Typography
} from '@mui/material';
import { OpenInNew } from '@mui/icons-material';

const DetailsFieldsSection = ({
  formData,
  handleChange,
  dropdownOptions,
  handleNavigateToMasterData,
  readOnly = false
}) => {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <FormControl fullWidth required sx={{ minWidth: 200 }}>
            <InputLabel sx={{ fontSize: '14px' }}>Manufacturer</InputLabel>
            <Select
              value={formData.manufacturerId || ''}
              label="Manufacturer"
              onChange={handleChange('manufacturerId')}
              disabled={readOnly}
              sx={{ minWidth: 200 }}
              MenuProps={{
                autoWidth: false,
                PaperProps: {
                  sx: {
                    maxHeight: 400,
                    minWidth: 700,
                    width: 'auto',
                    backgroundColor: '#ffffff',
                    '& .MuiMenuItem-root': {
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                      padding: '12px 16px',
                      minHeight: 'auto',
                      lineHeight: 1.5,
                      overflow: 'visible',
                      textOverflow: 'unset',
                      color: '#212121',
                      fontSize: '14px',
                      fontWeight: 400,
                      backgroundColor: '#ffffff',
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                        color: '#212121'
                      },
                      '&.Mui-selected': {
                        backgroundColor: '#e3f2fd',
                        color: '#1976d2',
                        '&:hover': {
                          backgroundColor: '#bbdefb'
                        }
                      }
                    }
                  }
                },
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
              }}
            >
              {(dropdownOptions.manufacturerNames || []).map((mn) => (
                <MenuItem key={mn._id} value={mn._id}>
                  {mn.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {!readOnly && (
            <Link
              component="button"
              type="button"
              onClick={() => handleNavigateToMasterData('manufacturer-names', 1, 0)}
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 0.5,
                fontSize: '0.875rem',
                textDecoration: 'none',
                whiteSpace: 'nowrap',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              Add Manufacturer
              <OpenInNew sx={{ fontSize: '0.875rem' }} />
            </Link>
          )}
        </Box>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <FormControl fullWidth required sx={{ minWidth: 200 }}>
            <InputLabel sx={{ fontSize: '14px' }}>Monitor Type</InputLabel>
            <Select
              value={formData.monitorTypeId || ''}
              label="Monitor Type"
              onChange={handleChange('monitorTypeId')}
              disabled={readOnly}
              sx={{ minWidth: 200 }}
              MenuProps={{
                autoWidth: false,
                PaperProps: {
                  sx: {
                    maxHeight: 400,
                    minWidth: 700,
                    width: 'auto',
                    backgroundColor: '#ffffff',
                    '& .MuiMenuItem-root': {
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                      padding: '12px 16px',
                      minHeight: 'auto',
                      lineHeight: 1.5,
                      overflow: 'visible',
                      textOverflow: 'unset',
                      color: '#212121',
                      fontSize: '14px',
                      fontWeight: 400,
                      backgroundColor: '#ffffff',
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                        color: '#212121'
                      },
                      '&.Mui-selected': {
                        backgroundColor: '#e3f2fd',
                        color: '#1976d2',
                        '&:hover': {
                          backgroundColor: '#bbdefb'
                        }
                      }
                    }
                  }
                },
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
              }}
            >
              {dropdownOptions.monitorTypes.map((mt) => (
                <MenuItem key={mt._id} value={mt._id}>
                  {mt.code} - {mt.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {!readOnly && (
            <Link
              component="button"
              type="button"
              onClick={() => handleNavigateToMasterData('monitor-types', 6)}
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 0.5,
                fontSize: '0.875rem',
                textDecoration: 'none',
                whiteSpace: 'nowrap',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              Add Monitor Type
              <OpenInNew sx={{ fontSize: '0.875rem' }} />
            </Link>
          )}
        </Box>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Installed On Date"
          type="date"
          value={formData.installedOnDate || ''}
          onChange={handleChange('installedOnDate')}
          InputLabelProps={{ shrink: true }}
          required
          helperText="For initial load (e.g. aircraft purchase), use as the reference date for the entered times (e.g. delivery or purchase date)."
          disabled={readOnly}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <FormControl fullWidth required sx={{ minWidth: 200 }}>
            <InputLabel sx={{ fontSize: '14px' }}>License</InputLabel>
            <Select
              value={formData.licenseId || ''}
              label="License"
              onChange={handleChange('licenseId')}
              disabled={readOnly}
              sx={{ minWidth: 200 }}
              MenuProps={{
                autoWidth: false,
                PaperProps: {
                  sx: {
                    maxHeight: 400,
                    minWidth: 700,
                    width: 'auto',
                    backgroundColor: '#ffffff',
                    '& .MuiMenuItem-root': {
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                      padding: '12px 16px',
                      minHeight: 'auto',
                      lineHeight: 1.5,
                      overflow: 'visible',
                      textOverflow: 'unset',
                      color: '#212121',
                      fontSize: '14px',
                      fontWeight: 400,
                      backgroundColor: '#ffffff',
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                        color: '#212121'
                      },
                      '&.Mui-selected': {
                        backgroundColor: '#e3f2fd',
                        color: '#1976d2',
                        '&:hover': {
                          backgroundColor: '#bbdefb'
                        }
                      }
                    }
                  }
                },
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
              }}
            >
              {dropdownOptions.licenses.map((license) => (
                <MenuItem key={license._id} value={license._id}>
                  {license.licenseNumber} - {license.employeeName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {!readOnly && (
            <Link
              component="button"
              type="button"
              onClick={() => handleNavigateToMasterData('licenses', 4)}
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 0.5,
                fontSize: '0.875rem',
                textDecoration: 'none',
                whiteSpace: 'nowrap',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              Add License
              <OpenInNew sx={{ fontSize: '0.875rem' }} />
            </Link>
          )}
        </Box>
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth required>
          <InputLabel>Component State</InputLabel>
          <Select
            value={formData.isActive === false ? 'INACTIVE' : 'ACTIVE'}
            label="Component State"
            onChange={(event) =>
              handleChange('isActive')({
                target: { value: event.target.value === 'ACTIVE' }
              })
            }
            disabled={readOnly}
          >
            <MenuItem value="ACTIVE">Active (installed on aircraft)</MenuItem>
            <MenuItem value="INACTIVE">Inactive (removed, values paused)</MenuItem>
          </Select>
        </FormControl>
        <Typography variant="caption" display="block" sx={{ mt: 0.5, color: 'text.secondary' }}>
          Set to Inactive when this component is removed from the aircraft. Lifecycle values remain paused until reactivated.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={!!formData.isInitialLoad}
              onChange={handleChange('isInitialLoad')}
              disabled={readOnly}
            />
          }
          label="Initial load (e.g. aircraft purchase)"
        />
        <Typography variant="caption" display="block" sx={{ mt: 0.5, color: 'text.secondary' }}>
          Check when adding a component that was already on the aircraft (no work order for this installation).
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Work Order Number"
          value={formData.workOrderNumber || ''}
          onChange={handleChange('workOrderNumber')}
          disabled={readOnly}
        />
      </Grid>
      <Grid item xs={12}>
        <Alert severity="info" sx={{ py: 0.5 }}>
          For initial load (e.g. aircraft purchase), leave Work Order blank and enter current utilization in Time Since Records.
        </Alert>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth sx={{ minWidth: 200 }}>
          <InputLabel sx={{ fontSize: '14px' }}>As-received evidence from</InputLabel>
          <Select
            value={formData.asReceivedEvidenceFrom || ''}
            label="As-received evidence from"
            onChange={handleChange('asReceivedEvidenceFrom')}
            disabled={readOnly}
            displayEmpty
            sx={{ minWidth: 200 }}
            MenuProps={{
              autoWidth: false,
              PaperProps: {
                sx: {
                  maxHeight: 400,
                  minWidth: 700,
                  width: 'auto',
                  backgroundColor: '#ffffff',
                  '& .MuiMenuItem-root': {
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                    padding: '12px 16px',
                    minHeight: 'auto',
                    lineHeight: 1.5,
                    overflow: 'visible',
                    textOverflow: 'unset',
                    color: '#212121',
                    fontSize: '14px',
                    fontWeight: 400,
                    backgroundColor: '#ffffff',
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                      color: '#212121'
                    },
                    '&.Mui-selected': {
                      backgroundColor: '#e3f2fd',
                      color: '#1976d2',
                      '&:hover': {
                        backgroundColor: '#bbdefb'
                      }
                    }
                  }
                }
              },
              anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
              transformOrigin: { vertical: 'top', horizontal: 'left' }
            }}
          >
            <MenuItem value="">—</MenuItem>
            <MenuItem value="logbook">Logbook</MenuItem>
            <MenuItem value="seller">Seller</MenuItem>
            <MenuItem value="OEM">OEM</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Notes"
          value={formData.notes || ''}
          onChange={handleChange('notes')}
          multiline
          rows={3}
          disabled={readOnly}
        />
      </Grid>
    </>
  );
};

export default DetailsFieldsSection;
